var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _path20, _g10, _path21, _path22, _g11, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 30,
    viewBox: "0 0 83 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18462 14.8809C0.983283 14.8809 0 15.862 0 17.0602C0 18.2585 0.983283 19.2396 2.18462 19.2396H5.19721C6.39854 19.2396 7.38182 18.2585 7.38182 17.0602C7.38182 15.862 6.39854 14.8809 5.19721 14.8809H2.18462Z",
    fill: "url(#paint0_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 8,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18462 14.8809C0.983283 14.8809 0 15.862 0 17.0602C0 18.2585 0.983283 19.2396 2.18462 19.2396H5.19721C6.39854 19.2396 7.38182 18.2585 7.38182 17.0602C7.38182 15.862 6.39854 14.8809 5.19721 14.8809H2.18462Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38298 14.8809H0.00115967V19.2396H7.38298V14.8809Z",
    fill: "url(#paint1_linear_4203_105665)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3319 9.74984V14.0113C25.3319 14.5777 25.1745 15.0242 24.8536 15.3745C24.5368 15.7237 24.1069 15.8937 23.5401 15.8937C22.5332 15.8937 21.8626 15.5773 21.8626 14.0318V9.74984C21.8626 8.67551 21.1899 8.00879 20.1069 8.00879C19.03 8.00879 18.3615 8.67551 18.3615 9.74984V14.1158C18.3615 15.5803 18.7626 16.7888 19.5546 17.7085C20.4031 18.6978 21.5581 19.1997 22.9858 19.1997C23.9032 19.1997 24.6993 18.9856 25.3524 18.5626L25.588 18.4101L25.7824 18.6128C26.0909 18.9354 26.5383 19.1055 27.0783 19.1055C28.1552 19.1055 28.8237 18.4305 28.8237 17.3429V9.74984C28.8237 8.67551 28.1552 8.00879 27.0783 8.00879C26.0014 8.00879 25.3319 8.67551 25.3319 9.74984Z",
    fill: "url(#paint2_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 11,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3319 9.74984V14.0113C25.3319 14.5777 25.1745 15.0242 24.8536 15.3745C24.5368 15.7237 24.1069 15.8937 23.5401 15.8937C22.5332 15.8937 21.8626 15.5773 21.8626 14.0318V9.74984C21.8626 8.67551 21.1899 8.00879 20.1069 8.00879C19.03 8.00879 18.3615 8.67551 18.3615 9.74984V14.1158C18.3615 15.5803 18.7626 16.7888 19.5546 17.7085C20.4031 18.6978 21.5581 19.1997 22.9858 19.1997C23.9032 19.1997 24.6993 18.9856 25.3524 18.5626L25.588 18.4101L25.7824 18.6128C26.0909 18.9354 26.5383 19.1055 27.0783 19.1055C28.1552 19.1055 28.8237 18.4305 28.8237 17.3429V9.74984C28.8237 8.67551 28.1552 8.00879 27.0783 8.00879C26.0014 8.00879 25.3319 8.67551 25.3319 9.74984Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8236 8.00879H18.3603V19.1997H28.8236V8.00879Z",
    fill: "url(#paint3_linear_4203_105665)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3344 8.64894L35.0979 8.80154L34.9045 8.59876C34.5949 8.2741 34.1424 8.10204 33.5962 8.10204C32.5193 8.10204 31.8508 8.77696 31.8508 9.86461V17.4576C31.8508 18.532 32.5193 19.1987 33.5962 19.1987C34.6793 19.1987 35.3519 18.531 35.3519 17.4576V13.2064C35.3519 12.6308 35.5052 12.1823 35.8199 11.833C36.1367 11.4838 36.5666 11.3138 37.1344 11.3138C38.1475 11.3138 38.8222 11.6323 38.8222 13.1859V17.4576C38.8222 18.532 39.4908 19.1987 40.5676 19.1987C41.6445 19.1987 42.3131 18.531 42.3131 17.4576V13.0917C42.3131 11.6282 41.9119 10.4197 41.12 9.49899C40.2786 8.5158 39.1236 8.01807 37.6888 8.01807C36.7775 8.01807 35.9845 8.23109 35.3344 8.64894Z",
    fill: "url(#paint4_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 8,
    width: 12,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3344 8.64894L35.0979 8.80154L34.9045 8.59876C34.5949 8.2741 34.1424 8.10204 33.5962 8.10204C32.5193 8.10204 31.8508 8.77696 31.8508 9.86461V17.4576C31.8508 18.532 32.5193 19.1987 33.5962 19.1987C34.6793 19.1987 35.3519 18.531 35.3519 17.4576V13.2064C35.3519 12.6308 35.5052 12.1823 35.8199 11.833C36.1367 11.4838 36.5666 11.3138 37.1344 11.3138C38.1475 11.3138 38.8222 11.6323 38.8222 13.1859V17.4576C38.8222 18.532 39.4908 19.1987 40.5676 19.1987C41.6445 19.1987 42.3131 18.531 42.3131 17.4576V13.0917C42.3131 11.6282 41.9119 10.4197 41.12 9.49899C40.2786 8.5158 39.1236 8.01807 37.6888 8.01807C36.7775 8.01807 35.9845 8.23109 35.3344 8.64894Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3153 8.01807H31.8519V19.1987H42.3153V8.01807Z",
    fill: "url(#paint5_linear_4203_105665)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.54 9.84408V17.4586C59.54 18.533 60.2137 19.1997 61.2968 19.1997C62.3737 19.1997 63.0422 18.5319 63.0422 17.4586V9.84408C63.0422 8.76975 62.3737 8.10303 61.2968 8.10303C60.2127 8.102 59.54 8.76975 59.54 9.84408Z",
    fill: "url(#paint6_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 8,
    width: 5,
    height: 12
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.54 9.84408V17.4586C59.54 18.533 60.2137 19.1997 61.2968 19.1997C62.3737 19.1997 63.0422 18.5319 63.0422 17.4586V9.84408C63.0422 8.76975 62.3737 8.10303 61.2968 8.10303C60.2127 8.102 59.54 8.76975 59.54 9.84408Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0411 8.10181H59.5389V19.1995H63.0411V8.10181Z",
    fill: "url(#paint7_linear_4203_105665)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.062 9.84408V17.4586C66.062 18.533 66.7347 19.1997 67.8177 19.1997C68.8946 19.1997 69.5632 18.5319 69.5632 17.4586V9.84408C69.5632 8.76975 68.8946 8.10303 67.8177 8.10303C66.7347 8.102 66.062 8.76975 66.062 9.84408Z",
    fill: "url(#paint8_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 8,
    width: 4,
    height: 12
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.062 9.84408V17.4586C66.062 18.533 66.7347 19.1997 67.8177 19.1997C68.8946 19.1997 69.5632 18.5319 69.5632 17.4586V9.84408C69.5632 8.76975 68.8946 8.10303 67.8177 8.10303C66.7347 8.102 66.062 8.76975 66.062 9.84408Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5642 8.10181H66.062V19.1995H69.5642V8.10181Z",
    fill: "url(#paint9_linear_4203_105665)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0203 8.64894L75.7838 8.80154L75.5894 8.59876C75.2798 8.2741 74.8272 8.10204 74.2821 8.10204C73.2052 8.10204 72.5356 8.77696 72.5356 9.86461V17.4576C72.5356 18.532 73.2042 19.1987 74.2821 19.1987C75.3652 19.1987 76.0378 18.531 76.0378 17.4576V13.2064C76.0378 12.6308 76.1911 12.1823 76.5058 11.833C76.8226 11.4838 77.2525 11.3138 77.8203 11.3138C78.8334 11.3138 79.5081 11.6323 79.5081 13.1859V17.4576C79.5081 18.532 80.1767 19.1987 81.2535 19.1987C82.3304 19.1987 83 18.531 83 17.4576V13.0917C83 11.6282 82.5989 10.4197 81.8069 9.49899C80.9656 8.5158 79.8105 8.01807 78.3757 8.01807C77.4623 8.01807 76.6693 8.23109 76.0203 8.64894Z",
    fill: "url(#paint10_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 8,
    width: 11,
    height: 12
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0203 8.64894L75.7838 8.80154L75.5894 8.59876C75.2798 8.2741 74.8272 8.10204 74.2821 8.10204C73.2052 8.10204 72.5356 8.77696 72.5356 9.86461V17.4576C72.5356 18.532 73.2042 19.1987 74.2821 19.1987C75.3652 19.1987 76.0378 18.531 76.0378 17.4576V13.2064C76.0378 12.6308 76.1911 12.1823 76.5058 11.833C76.8226 11.4838 77.2525 11.3138 77.8203 11.3138C78.8334 11.3138 79.5081 11.6323 79.5081 13.1859V17.4576C79.5081 18.532 80.1767 19.1987 81.2535 19.1987C82.3304 19.1987 83 18.531 83 17.4576V13.0917C83 11.6282 82.5989 10.4197 81.8069 9.49899C80.9656 8.5158 79.8105 8.01807 78.3757 8.01807C77.4623 8.01807 76.6693 8.23109 76.0203 8.64894Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.0001 8.01807H72.5368V19.1987H83.0001V8.01807Z",
    fill: "url(#paint11_linear_4203_105665)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3925 15.4022C48.9883 14.9465 48.7929 14.3443 48.7929 13.5618C48.7929 12.7732 48.9904 12.1659 49.3956 11.7081C49.7751 11.2749 50.274 11.0629 50.9209 11.0629C51.5411 11.0629 52.042 11.2995 52.4514 11.7849C52.8731 12.2775 53.0685 12.8429 53.0685 13.5608C53.0685 14.2746 52.8721 14.8389 52.4493 15.3377C52.042 15.816 51.5422 16.0485 50.9199 16.0485C50.2729 16.0505 49.7731 15.8375 49.3925 15.4022ZM53.0675 4.78895V8.61518L52.5789 8.37552C51.969 8.07647 51.2727 7.9249 50.5116 7.9249C49.0428 7.9249 47.7983 8.45234 46.8119 9.49287C45.8019 10.557 45.2897 11.9252 45.2897 13.5628C45.2897 15.1492 45.7998 16.4981 46.8057 17.5744C47.8055 18.6539 49.0531 19.2008 50.5105 19.2008C51.5144 19.2008 52.3856 18.9673 53.1025 18.5064L53.3514 18.3477L53.5437 18.5709C53.8461 18.9222 54.3038 19.1076 54.8654 19.1076C55.9165 19.1076 56.5697 18.4398 56.5697 17.3655V4.78895C56.5697 3.71462 55.9011 3.04688 54.8242 3.04688C53.7412 3.04688 53.0675 3.71462 53.0675 4.78895Z",
    fill: "url(#paint12_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 3,
    width: 12,
    height: 17
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3925 15.4022C48.9883 14.9465 48.7929 14.3443 48.7929 13.5618C48.7929 12.7732 48.9904 12.1659 49.3956 11.7081C49.7751 11.2749 50.274 11.0629 50.9209 11.0629C51.5411 11.0629 52.042 11.2995 52.4514 11.7849C52.8731 12.2775 53.0685 12.8429 53.0685 13.5608C53.0685 14.2746 52.8721 14.8389 52.4493 15.3377C52.042 15.816 51.5422 16.0485 50.9199 16.0485C50.2729 16.0505 49.7731 15.8375 49.3925 15.4022ZM53.0675 4.78895V8.61518L52.5789 8.37552C51.969 8.07647 51.2727 7.9249 50.5116 7.9249C49.0428 7.9249 47.7983 8.45234 46.8119 9.49287C45.8019 10.557 45.2897 11.9252 45.2897 13.5628C45.2897 15.1492 45.7998 16.4981 46.8057 17.5744C47.8055 18.6539 49.0531 19.2008 50.5105 19.2008C51.5144 19.2008 52.3856 18.9673 53.1025 18.5064L53.3514 18.3477L53.5437 18.5709C53.8461 18.9222 54.3038 19.1076 54.8654 19.1076C55.9165 19.1076 56.5697 18.4398 56.5697 17.3655V4.78895C56.5697 3.71462 55.9011 3.04688 54.8242 3.04688C53.7412 3.04688 53.0675 3.71462 53.0675 4.78895Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5697 3.04688H45.2897V19.1987H56.5697V3.04688Z",
    fill: "url(#paint13_linear_4203_105665)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18462 7.44243L2.07251 7.44448C0.922599 7.50286 0 8.45941 0 9.6208C0 10.8191 0.983283 11.8002 2.18462 11.8002H12.2777L12.3898 11.7971C13.5397 11.7387 14.4623 10.7812 14.4623 9.6208C14.4623 8.42254 13.48 7.44141 12.2777 7.44141H2.18462H12.2777H2.18462V7.44243Z",
    fill: "url(#paint14_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 15,
    height: 5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18462 7.44243L2.07251 7.44448C0.922599 7.50286 0 8.45941 0 9.6208C0 10.8191 0.983283 11.8002 2.18462 11.8002H12.2777L12.3898 11.7971C13.5397 11.7387 14.4623 10.7812 14.4623 9.6208C14.4623 8.42254 13.48 7.44141 12.2777 7.44141H2.18462H12.2777H2.18462V7.44243Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4624 7.44263H0.00115967V11.8014H14.4624V7.44263Z",
    fill: "url(#paint15_linear_4203_105665)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7128 4.91591C59.7128 5.90421 60.3042 6.49412 61.2947 6.49412C62.2646 6.49412 62.8684 5.88885 62.8684 4.91591C62.8684 3.94194 62.2646 3.33667 61.2947 3.33667C60.3042 3.33769 59.7128 3.92761 59.7128 4.91591Z",
    fill: "url(#paint16_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 3,
    width: 4,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7128 4.91591C59.7128 5.90421 60.3042 6.49412 61.2947 6.49412C62.2646 6.49412 62.8684 5.88885 62.8684 4.91591C62.8684 3.94194 62.2646 3.33667 61.2947 3.33667C60.3042 3.33769 59.7128 3.92761 59.7128 4.91591Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8684 3.33789H59.7128V6.49534H62.8684V3.33789Z",
    fill: "url(#paint17_linear_4203_105665)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2348 4.91591C66.2348 5.90421 66.8262 6.49412 67.8167 6.49412C68.7876 6.49412 69.3904 5.88885 69.3904 4.91591C69.3904 3.94194 68.7876 3.33667 67.8167 3.33667C66.8272 3.33769 66.2348 3.92761 66.2348 4.91591Z",
    fill: "url(#paint18_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 3,
    width: 4,
    height: 4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2348 4.91591C66.2348 5.90421 66.8262 6.49412 67.8167 6.49412C68.7876 6.49412 69.3904 5.88885 69.3904 4.91591C69.3904 3.94194 68.7876 3.33667 67.8167 3.33667C66.8272 3.33769 66.2348 3.92761 66.2348 4.91591Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3904 3.33789H66.2348V6.49534H69.3904V3.33789Z",
    fill: "url(#paint19_linear_4203_105665)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18462 0L2.07251 0.00307232C0.9226 0.0614488 0 1.018 0 2.17939C0 3.37764 0.983283 4.35878 2.18462 4.35878H18.3028L18.415 4.35571C19.5649 4.29733 20.4875 3.34078 20.4875 2.17939C20.4875 0.981135 19.5052 0 18.3028 0H2.18462Z",
    fill: "url(#paint20_linear_4203_105665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_4203_105665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18462 0L2.07251 0.00307232C0.9226 0.0614488 0 1.018 0 2.17939C0 3.37764 0.983283 4.35878 2.18462 4.35878H18.3028L18.415 4.35571C19.5649 4.29733 20.4875 3.34078 20.4875 2.17939C20.4875 0.981135 19.5052 0 18.3028 0H2.18462Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_4203_105665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4886 0H0.00115967V4.35775H20.4886V0Z",
    fill: "url(#paint21_linear_4203_105665)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3731 25.8014V27.8865H20.2458V22.2681H22.2998C22.6413 22.2681 22.9375 22.3111 23.1905 22.3951C23.4435 22.4801 23.6523 22.6009 23.8179 22.7576C23.9825 22.9143 24.1069 23.1007 24.1892 23.3188C24.2715 23.536 24.3137 23.7777 24.3137 24.0429C24.3137 24.303 24.2705 24.5407 24.1861 24.7547C24.1008 24.9698 23.9732 25.1551 23.8025 25.3118C23.6317 25.4685 23.4219 25.5894 23.171 25.6744C22.921 25.7594 22.6299 25.8014 22.2998 25.8014H21.3731ZM22.1805 24.9022C22.5487 24.9022 22.8048 24.8233 22.9519 24.6666C23.0979 24.5099 23.172 24.3 23.172 24.0388C23.172 23.7674 23.099 23.5534 22.9519 23.3987C22.8048 23.2441 22.5487 23.1673 22.1805 23.1673H21.3731V24.9022H22.1805Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5824 23.4224C27.966 23.4224 28.29 23.5115 28.5533 23.6907C28.8166 23.8699 29.0017 24.1014 29.1087 24.3851V23.4777H30.236V27.8866H29.1087L29.1149 26.9639C29.0079 27.2558 28.8228 27.4923 28.5584 27.6726C28.2941 27.8528 27.9701 27.943 27.5854 27.943C27.3077 27.943 27.0485 27.8918 26.8089 27.7873C26.5682 27.6838 26.3605 27.5353 26.1846 27.3418C26.0087 27.1482 25.8709 26.9116 25.7721 26.6331C25.6734 26.3545 25.624 26.037 25.624 25.6816C25.624 25.3263 25.6734 25.0088 25.7721 24.7302C25.8709 24.4516 26.0077 24.2161 26.1835 24.0225C26.3594 23.8289 26.5672 23.6804 26.8068 23.577C27.0475 23.4736 27.3057 23.4224 27.5824 23.4224ZM27.9341 24.3933C27.5875 24.3933 27.3067 24.5049 27.0907 24.7292C26.8747 24.9524 26.7667 25.2689 26.7667 25.6796C26.7667 26.0841 26.8747 26.3975 27.0907 26.6218C27.3067 26.8451 27.5875 26.9567 27.9341 26.9567C28.1049 26.9567 28.2602 26.927 28.4021 26.8686C28.543 26.8103 28.6675 26.7252 28.7734 26.6136C28.8793 26.502 28.9627 26.3678 29.0213 26.2101C29.0799 26.0534 29.1087 25.8762 29.1087 25.6796C29.1087 25.4768 29.0789 25.2976 29.0213 25.1409C28.9627 24.9842 28.8804 24.85 28.7734 24.7374C28.6664 24.6247 28.543 24.5407 28.4021 24.4824C28.2612 24.4219 28.1049 24.3933 27.9341 24.3933Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8094 23.4776L34.0159 26.4701L35.1349 23.4776H36.3733L33.6641 29.9871H32.4175L33.4162 27.7585L31.5546 23.4766H32.8094V23.4776Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3607 27.0273H43.2553V27.8865H40.2344V22.2681H41.3617V27.0273H41.3607Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4602 23.4224C46.8438 23.4224 47.1678 23.5115 47.4311 23.6907C47.6944 23.8699 47.8796 24.1014 47.9865 24.3851V23.4777H49.1138V27.8866H47.9865L47.9927 26.9639C47.8857 27.2558 47.7006 27.4923 47.4363 27.6726C47.1719 27.8528 46.8479 27.943 46.4633 27.943C46.1856 27.943 45.9264 27.8918 45.6867 27.7873C45.446 27.6838 45.2383 27.5353 45.0624 27.3418C44.8865 27.1482 44.7487 26.9116 44.6499 26.6331C44.5512 26.3545 44.5018 26.037 44.5018 25.6816C44.5018 25.3263 44.5512 25.0088 44.6499 24.7302C44.7487 24.4516 44.8855 24.2161 45.0614 24.0225C45.2372 23.8289 45.445 23.6804 45.6847 23.577C45.9243 23.4736 46.1825 23.4224 46.4602 23.4224ZM46.8119 24.3933C46.4653 24.3933 46.1845 24.5049 45.9685 24.7292C45.7525 24.9524 45.6445 25.2689 45.6445 25.6796C45.6445 26.0841 45.7525 26.3975 45.9685 26.6218C46.1845 26.8451 46.4653 26.9567 46.8119 26.9567C46.9827 26.9567 47.138 26.927 47.2799 26.8686C47.4208 26.8103 47.5453 26.7252 47.6512 26.6136C47.7572 26.502 47.8405 26.3678 47.8991 26.2101C47.9577 26.0534 47.9865 25.8762 47.9865 25.6796C47.9865 25.4768 47.9567 25.2976 47.8991 25.1409C47.8405 24.9842 47.7582 24.85 47.6512 24.7374C47.5442 24.6247 47.4208 24.5407 47.2799 24.4824C47.138 24.4219 46.9816 24.3933 46.8119 24.3933Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 26.9157V27.8866H52.7024C52.473 27.8866 52.2642 27.86 52.075 27.8068C51.8857 27.7535 51.7232 27.6675 51.5874 27.5477C51.4517 27.4278 51.3478 27.2691 51.2758 27.0704C51.2038 26.8717 51.1678 26.6259 51.1678 26.334V24.424H50.5517V23.4767H51.1668V22.387H52.294V23.4767H53.2856V24.424H52.294V26.3433C52.294 26.5604 52.3372 26.7099 52.4226 26.7918C52.508 26.8738 52.652 26.9147 52.8536 26.9147H53.2938V26.9157Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0557 25.5145C59.0557 25.5893 59.0515 25.6548 59.0433 25.7132C59.0351 25.7716 59.0258 25.833 59.0155 25.8965H55.7787C55.789 26.1085 55.824 26.2877 55.8826 26.4342C55.9412 26.5796 56.0184 26.6984 56.114 26.7885C56.2097 26.8787 56.3197 26.9432 56.4452 26.9831C56.5707 27.0231 56.6993 27.0425 56.832 27.0425C57.0973 27.0425 57.3154 26.978 57.4851 26.8479C57.6548 26.7179 57.7638 26.5468 57.8122 26.3348H59.0001C58.9569 26.5632 58.8767 26.7752 58.7564 26.9719C58.637 27.1685 58.4848 27.3375 58.3017 27.4809C58.1187 27.6243 57.9068 27.7369 57.6671 27.8188C57.4275 27.9008 57.1673 27.9428 56.8854 27.9428C56.5614 27.9428 56.2642 27.8916 55.9958 27.7871C55.7273 27.6837 55.4949 27.5352 55.2974 27.3416C55.0999 27.148 54.9477 26.9104 54.8386 26.6288C54.7296 26.3482 54.6751 26.0317 54.6751 25.6814C54.6751 25.3261 54.7296 25.0086 54.8386 24.73C54.9477 24.4514 55.1009 24.2159 55.2974 24.0223C55.4938 23.8288 55.7263 23.6803 55.9958 23.5768C56.2642 23.4734 56.5614 23.4211 56.8854 23.4211C57.2207 23.4211 57.5211 23.4734 57.7864 23.5768C58.0528 23.6803 58.2801 23.8257 58.4684 24.0141C58.6576 24.2026 58.8016 24.4238 58.9034 24.6788C59.0053 24.9338 59.0557 25.2124 59.0557 25.5145ZM57.9284 25.4039C57.9387 25.2134 57.915 25.0475 57.8564 24.9062C57.7978 24.7659 57.7206 24.6511 57.625 24.5641C57.5293 24.477 57.4172 24.4115 57.2897 24.3695C57.1621 24.3275 57.0284 24.306 56.8896 24.306C56.6016 24.306 56.3516 24.3951 56.1387 24.5723C55.9258 24.7505 55.8055 25.027 55.7787 25.4039H57.9284Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7813 24.3215C61.9407 24.0511 62.1557 23.8319 62.4241 23.665C62.6936 23.498 63.0011 23.4141 63.3477 23.4141V24.6154H63.0207C62.8448 24.6154 62.6823 24.6338 62.5331 24.6707C62.384 24.7076 62.2534 24.77 62.1413 24.8581C62.0292 24.9452 61.9417 25.064 61.8769 25.2125C61.8132 25.361 61.7813 25.5443 61.7813 25.7614V27.8865H60.654V23.4776H61.7813V24.3215Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4203_105665",
    x1: 3.69165,
    y1: 18.7609,
    x2: 3.69165,
    y2: 4.58294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4203_105665",
    x1: 3.69175,
    y1: 18.7609,
    x2: 3.69175,
    y2: 4.58294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4203_105665",
    x1: 23.5919,
    y1: 18.7609,
    x2: 23.5919,
    y2: 4.58292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4203_105665",
    x1: 23.5917,
    y1: 18.7609,
    x2: 23.5917,
    y2: 4.58292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4203_105665",
    x1: 37.0834,
    y1: 18.7609,
    x2: 37.0834,
    y2: 4.58298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4203_105665",
    x1: 37.0835,
    y1: 18.7609,
    x2: 37.0835,
    y2: 4.58298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4203_105665",
    x1: 61.2905,
    y1: 18.7609,
    x2: 61.2905,
    y2: 4.58293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4203_105665",
    x1: 61.2904,
    y1: 18.7607,
    x2: 61.2904,
    y2: 4.58274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4203_105665",
    x1: 67.813,
    y1: 18.7609,
    x2: 67.813,
    y2: 4.58293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4203_105665",
    x1: 67.813,
    y1: 18.7607,
    x2: 67.813,
    y2: 4.58274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4203_105665",
    x1: 77.7685,
    y1: 18.7609,
    x2: 77.7685,
    y2: 4.58298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4203_105665",
    x1: 77.7687,
    y1: 18.7609,
    x2: 77.7687,
    y2: 4.58298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4203_105665",
    x1: 50.9297,
    y1: 18.761,
    x2: 50.9297,
    y2: 4.58301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4203_105665",
    x1: 50.9297,
    y1: 18.761,
    x2: 50.9297,
    y2: 4.58301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4203_105665",
    x1: 7.2316,
    y1: 18.7609,
    x2: 7.2316,
    y2: 4.58291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4203_105665",
    x1: 7.23171,
    y1: 18.7611,
    x2: 7.23171,
    y2: 4.58311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4203_105665",
    x1: 61.2908,
    y1: 18.7609,
    x2: 61.2908,
    y2: 4.58297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4203_105665",
    x1: 61.2908,
    y1: 18.7611,
    x2: 61.2908,
    y2: 4.58316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4203_105665",
    x1: 67.8131,
    y1: 18.7609,
    x2: 67.8131,
    y2: 4.58297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4203_105665",
    x1: 67.8131,
    y1: 18.7611,
    x2: 67.8131,
    y2: 4.58316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4203_105665",
    x1: 10.2443,
    y1: 18.7609,
    x2: 10.2443,
    y2: 4.58298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4203_105665",
    x1: 10.2444,
    y1: 18.7609,
    x2: 10.2444,
    y2: 4.58297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175678,
    stopColor: "#6D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3942,
    stopColor: "#3D93DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#11C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#00D6CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/_logo.88ccd115bb73f450c3ec4853c40c6cec.svg";
export { ForwardRef as ReactComponent };